var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoadingimg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 53,
    viewBox: "0 0 83 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83 37L56.4 13.4L41.6 0V0.2L41.4 0L26.2 13.8L0 37L13.4 52.2L41.2 27L69.6 52.2L83 37Z",
    fill: "url(#paint0_linear_1808_626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1808_626",
    x1: 0.0622,
    y1: 26.0872,
    x2: 82.9522,
    y2: 26.0872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    stopColor: "#31B66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#20B899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9089,
    stopColor: "#00BEE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFF3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingimg);
export default __webpack_public_path__ + "static/media/loadingimg.f8abb3c00a122df6b713fd0635c04077.svg";
export { ForwardRef as ReactComponent };